/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Aggregated statistics across all competition types
 * @export
 * @interface CompetitionStats
 */
export interface CompetitionStats {
    /**
     * Total count of tournaments, leagues, leaderboards, ladders, and challenges
     * @type {number}
     * @memberof CompetitionStats
     */
    totalCompetitions?: number;
    /**
     * Count of competitions with active status (registration, in progress, active)
     * @type {number}
     * @memberof CompetitionStats
     */
    activeCompetitions?: number;
    /**
     * Count of competitions with completed status
     * @type {number}
     * @memberof CompetitionStats
     */
    completedCompetitions?: number;
    /**
     * Count of matches currently in disputed status
     * @type {number}
     * @memberof CompetitionStats
     */
    pendingDisputes?: number;
    /**
     * Sum of participants across tournaments, leagues, leaderboards, and ladders
     * @type {number}
     * @memberof CompetitionStats
     */
    totalParticipants?: number;
    /**
     * Tournaments in REGISTRATION, READY, or IN_PROGRESS status
     * @type {number}
     * @memberof CompetitionStats
     */
    activeTournaments?: number;
    /**
     * Leagues in REGISTRATION, ACTIVE, or PLAYOFFS status
     * @type {number}
     * @memberof CompetitionStats
     */
    activeLeagues?: number;
    /**
     * Leaderboards in ACTIVE status
     * @type {number}
     * @memberof CompetitionStats
     */
    activeLeaderboards?: number;
    /**
     * Count of active guilds
     * @type {number}
     * @memberof CompetitionStats
     */
    activeGuildCompetitions?: number;
    /**
     * Ladders in ACTIVE status
     * @type {number}
     * @memberof CompetitionStats
     */
    activeLadders?: number;
    /**
     * Challenges that are active and not ended
     * @type {number}
     * @memberof CompetitionStats
     */
    activeChallenges?: number;
    /**
     * Hubs in ACTIVE status
     * @type {number}
     * @memberof CompetitionStats
     */
    activeHubs?: number;
    /**
     * Total tournament count
     * @type {number}
     * @memberof CompetitionStats
     */
    totalTournaments?: number;
    /**
     * Total league count
     * @type {number}
     * @memberof CompetitionStats
     */
    totalLeagues?: number;
    /**
     * Total leaderboard competition count
     * @type {number}
     * @memberof CompetitionStats
     */
    totalLeaderboards?: number;
    /**
     * Total ladder count
     * @type {number}
     * @memberof CompetitionStats
     */
    totalLadders?: number;
    /**
     * Total challenge count
     * @type {number}
     * @memberof CompetitionStats
     */
    totalChallenges?: number;
    /**
     * Total hub count
     * @type {number}
     * @memberof CompetitionStats
     */
    totalHubs?: number;
    /**
     * Total guild count
     * @type {number}
     * @memberof CompetitionStats
     */
    totalGuilds?: number;
}

/**
 * Check if a given object implements the CompetitionStats interface.
 */
export function instanceOfCompetitionStats(value: object): value is CompetitionStats {
    return true;
}

export function CompetitionStatsFromJSON(json: any): CompetitionStats {
    return CompetitionStatsFromJSONTyped(json, false);
}

export function CompetitionStatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitionStats {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCompetitions': json['totalCompetitions'] == null ? undefined : json['totalCompetitions'],
        'activeCompetitions': json['activeCompetitions'] == null ? undefined : json['activeCompetitions'],
        'completedCompetitions': json['completedCompetitions'] == null ? undefined : json['completedCompetitions'],
        'pendingDisputes': json['pendingDisputes'] == null ? undefined : json['pendingDisputes'],
        'totalParticipants': json['totalParticipants'] == null ? undefined : json['totalParticipants'],
        'activeTournaments': json['activeTournaments'] == null ? undefined : json['activeTournaments'],
        'activeLeagues': json['activeLeagues'] == null ? undefined : json['activeLeagues'],
        'activeLeaderboards': json['activeLeaderboards'] == null ? undefined : json['activeLeaderboards'],
        'activeGuildCompetitions': json['activeGuildCompetitions'] == null ? undefined : json['activeGuildCompetitions'],
        'activeLadders': json['activeLadders'] == null ? undefined : json['activeLadders'],
        'activeChallenges': json['activeChallenges'] == null ? undefined : json['activeChallenges'],
        'activeHubs': json['activeHubs'] == null ? undefined : json['activeHubs'],
        'totalTournaments': json['totalTournaments'] == null ? undefined : json['totalTournaments'],
        'totalLeagues': json['totalLeagues'] == null ? undefined : json['totalLeagues'],
        'totalLeaderboards': json['totalLeaderboards'] == null ? undefined : json['totalLeaderboards'],
        'totalLadders': json['totalLadders'] == null ? undefined : json['totalLadders'],
        'totalChallenges': json['totalChallenges'] == null ? undefined : json['totalChallenges'],
        'totalHubs': json['totalHubs'] == null ? undefined : json['totalHubs'],
        'totalGuilds': json['totalGuilds'] == null ? undefined : json['totalGuilds'],
    };
}

export function CompetitionStatsToJSON(json: any): CompetitionStats {
    return CompetitionStatsToJSONTyped(json, false);
}

export function CompetitionStatsToJSONTyped(value?: CompetitionStats | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalCompetitions': value['totalCompetitions'],
        'activeCompetitions': value['activeCompetitions'],
        'completedCompetitions': value['completedCompetitions'],
        'pendingDisputes': value['pendingDisputes'],
        'totalParticipants': value['totalParticipants'],
        'activeTournaments': value['activeTournaments'],
        'activeLeagues': value['activeLeagues'],
        'activeLeaderboards': value['activeLeaderboards'],
        'activeGuildCompetitions': value['activeGuildCompetitions'],
        'activeLadders': value['activeLadders'],
        'activeChallenges': value['activeChallenges'],
        'activeHubs': value['activeHubs'],
        'totalTournaments': value['totalTournaments'],
        'totalLeagues': value['totalLeagues'],
        'totalLeaderboards': value['totalLeaderboards'],
        'totalLadders': value['totalLadders'],
        'totalChallenges': value['totalChallenges'],
        'totalHubs': value['totalHubs'],
        'totalGuilds': value['totalGuilds'],
    };
}

